import { APICore } from './apiCore'

const api = new APICore()

function getInstanceOpinometros (params) {
  const baseUrl = '/instance-opinometro'
  return api.get(baseUrl, params)
}

function getInstanceOpinometro (id) {
  const baseUrl = `/instance-opinometro/${id}`
  return api.get(baseUrl, {})
}

function addInstanceOpinometro (params) {
  const baseUrl = '/instance-opinometro'
  return api.create(baseUrl, params)
}

function updateInstanceOpinometro (params) {
  const baseUrl = '/instance-opinometro'
  return api.update(baseUrl, params)
}

function deleteInstanceOpinometro (params) {
  const baseUrl = '/instance-opinometro'
  return api.delete(baseUrl, params)
}

export { getInstanceOpinometros, getInstanceOpinometro, addInstanceOpinometro, updateInstanceOpinometro, deleteInstanceOpinometro }
